<template>
	<div>
		<div class="row">
			<!-- First Name -->
			<div class="col-md-6">
				<div class="form-group">
					<label
						>First Name <span class="required-star">*</span></label
					>
					<app-input
						type="text"
						v-model="local_child.first_name"
						:required="true"
						name="first_name[]"
						placeholder="Child's First Name"
					/>
				</div>
			</div>
			<!-- Last Name -->
			<div class="col-md-6">
				<div class="form-group">
					<label
						>Last Name <span class="required-star">*</span></label
					>
					<app-input
						type="text"
						v-model="local_child.last_name"
						:required="true"
						name="last_name[]"
						placeholder="Child's Last Name"
					/>
				</div>
			</div>
		</div>
		<div class="row">
			<!-- Is the child CLC Student? -->
			<div class="col-md-6">
				<div class="form-group">
					<label for=""
						>Is the child CLC Student?
						<span class="required-star">*</span></label
					>
					<app-input
						type="radio"
						:list="yes_and_no_list"
						:isNeedName="false"
						:required="true"
						v-model="local_child.is_clc_student"
						name="is_clc_student[]"
					/>
				</div>
			</div>
			<!-- CLC ID No -->
			<div class="col-md-6" v-if="local_child.is_clc_student == 'yes'">
				<div class="form-group form row align-items-center">
					<label class="col-sm-2 mb-sm-0">
						CLC ID No <span class="required-star">*</span>
					</label>
					<app-input
						class="col-sm-8"
						type="text"
						:required="true"
						placeholder="CLC ID No"
						v-model="local_child.clc_id_no"
					/>
				</div>
			</div>
		</div>
		<div class="row" v-if="local_child.is_clc_student == 'no'">
			<!-- Child's Place of Birth -->
			<div class="col-md-3">
				<div class="form-group">
					<label
						>Place of Birth
						<span class="required-star">*</span></label
					>
					<app-input
						class="col-sm-8"
						type="text"
						:required="true"
						placeholder="Child's Place of Birth"
						v-model="local_child.place_of_birth"
					/>
				</div>
			</div>
			<!-- Child's Date of Birth -->
			<div class="col-md-3">
				<div class="form-group">
					<label
						>Date of Birth
						<span class="required-star">*</span></label
					>
					<app-input
						type="date"
						v-model="local_child.date_of_birth"
						:required="true"
						name="date_of_birth[]"
						placeholder="Child's Date of Birth"
					/>
				</div>
			</div>
			<!-- Child's School Name -->
			<div class="col-md-3">
				<div class="form-group">
					<label
						>School Name <span class="required-star">*</span></label
					>
					<app-input
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_school_name"
						@input="setSchoolName"
						fetch-url="public/school"
						placeholder="Child's School Name"
						list-value-field="name"
						required
					/>
				</div>
			</div>
			<!-- Child's School Level -->
			<div class="col-md-3">
				<div class="form-group">
					<label
						>School Level
						<span class="required-star">*</span></label
					>
					<app-input
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_school_level"
						@input="setSchoolLevel"
						fetch-url="public/school-level"
						placeholder="Child's School Level"
						list-value-field="name"
						required
					/>
				</div>
			</div>
		</div>
		<div class="row">
			<!-- Please choose one of the following session: -->
			<div class="col-md-12">
				<div class="form-group">
					<label for=""
						>Please choose one of the following session:</label
					>
					<app-input
						type="radio"
						:list="followingSessionLists"
						:isNeedName="false"
						:isNeedBr="true"
						v-model="local_child.event_detail_id"
						:isBr="'yes'"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "EventRegistrationFormChild",
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		followingSessionLists: {
			type: Array,
			default: () => {
				return [
					{
						id: 1,
						value: "Tuesday, 26/09/2023 15:15 - 17:15 at CLC Permata Hijau",
					},
					{
						id: 2,
						value: "Wednesday, 27/09/2023 15:15 - 17:15 at CLC Kebon Jeruk",
					},
				];
			},
		},
	},
	data() {
		return {
			local_child: {
				...this.value,
			},
			input_place_of_birth: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			input_school_name: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			input_school_level: this.value
				? this.value
					? {
							id: this.value.id || 0,
							name: this.value.name || "",
							code: this.value.code,
							is_active: this.value.is_active,
					  }
					: {
							id: this.value?.id || 0,
							name: this.value?.name || "",
							code: this.value?.code,
							is_active: this.value?.is_active,
					  }
				: {
						id: this.value.id || 0,
						name: this.value.name || "",
						code: this.value.code,
						is_active: this.value.is_active,
				  },
			yes_and_no_list: [
				{ id: "no", value: "No" },
				{ id: "yes", value: "Yes" },
			],
		};
	},
	methods: {
		resetPlaceOfBirth() {
			this.input_place_of_birth = {
				country_id: undefined,
				city_id: undefined,
				code: "",
				name: "",
				is_active: "",
				city: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		setPlaceOfBirth(data) {
			this.local_child.place_of_birth = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.local_child.place_of_birth = data.id;
			}
		},
		setSchoolName(data) {
			this.local_child.school_name = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.local_child.school_name = data.id;
			}
		},
		setSchoolLevel(data) {
			this.local_child.school_level = data.id;
			if (data && data.hasOwnProperty("id")) {
				this.local_child.school_level = data.id;
			}
		},
	},
	watch: {
		local_child: {
			handler(newVal) {
				this.$emit("input", newVal);
			},
			deep: true,
		},
		"local_child.selected_country": {
			handler(oldVal, newVal) {
				if (newVal) {
					this.resetPlaceOfBirth();
				}
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
/* Style for required asterisk */
.required-star {
	color: red;
}
.mt-4 {
	margin-top: 4rem !important;
}
.mt-2 {
	margin-top: 2rem !important;
}
</style>
